<template>
  <div style="height: 100%" :key="selectedProject">
    <v-card
      class="d-flex flex-column"
      min-height="100%"
    >
      <v-card-title>
        PR Matrix Summary List
        <v-spacer></v-spacer>
        <v-text-field
          dense
          hide-details
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-4">
        <v-data-table
          :key="updateTable"
          dense
          :headers="headers"
          :items="listOfMetricsSummary"
          :items-per-page="-1"
          :search="search"
          hide-default-footer
        >
          <template v-slot:[`item.Actions`] = "{ item }">
            <v-btn small icon color="success" @click="showDetailsDialog(item)">
              <v-icon>mdi-pencil-circle</v-icon>
            </v-btn>
            <v-btn small icon color="red darken-2" @click="showDeleteDialog(item.Summary_ID)">
              <v-icon>mdi-delete-circle</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider class="mt-auto"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="showDetailsDialog(false)">Create</v-btn>
      </v-card-actions>
    </v-card>
    <MetricDetails
      v-if="showDetails"
      :summary="currentSummary"
      @updateSummary="getMetricsSummaryList(selectedProject)"
      v-model="showDetails"
    />
    <v-dialog
      v-model="deleteDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>Are you sure?</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          You can't restore deleted summary and metrics!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" @click="hideDeleteDialog">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2 white--text" @click="deleteSummary">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
export default {
  name: 'MetricsListByProject',
  components: {
    MetricDetails: () => import('@/components/metrics/MetricDetails')
  },
  data () {
    return {
      search: '',
      showDetails: false,
      currentSummary: null,
      deleteDialog: false,
      deleteSummaryID: null,
      listOfMetricsSummary: [],
      updateTable: 0,
      headers: [
        {
          text: 'From date',
          value: 'Date_From',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: 'auto'
        },
        {
          text: 'To date',
          value: 'Date_To',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: 'auto'
        },
        {
          text: 'Name',
          value: 'Name',
          divider: true,
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: '100%'
        },
        {
          text: '',
          value: 'Actions',
          cellClass: 'text-no-wrap',
          class: 'text-no-wrap',
          width: '50px'
        }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    selectedProject () {
      const projectID = this.$store.getters.getSelectedProject
      this.getMetricsSummaryList(projectID)
      return projectID
    }
  },
  methods: {
    showDeleteDialog (summaryId) {
      this.deleteSummaryID = summaryId
      this.deleteDialog = true
    },
    hideDeleteDialog () {
      this.deleteSummaryID = null
      this.deleteDialog = false
    },
    showDetailsDialog (item) {
      if (item) {
        this.currentSummary = item
      } else {
        this.currentSummary = null
      }
      this.showDetails = true
    },
    deleteSummary () {
      this.axios.delete(`/api/metrics/delete_summary/${this.deleteSummaryID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Summary and metrics successfully deleted' })
        this.hideDeleteDialog()
        this.getMetricsSummaryList(this.selectedProject)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getMetricsSummaryList (projectID) {
      this.currentSummary = null
      this.axios.get(`/api/metrics/get_metrics_summary_by_project_id/${projectID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.listOfMetricsSummary = []
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].Date_From = formatLocalDate(res.data[i].Date_From)
          res.data[i].Date_To = formatLocalDate(res.data[i].Date_To)
          this.listOfMetricsSummary.push(res.data[i])
        }
        this.updateTable++
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    }
  }
}
</script>
